module.exports = __webpack_public_path__ + "static/media/JVcall.fbc94bb7.mp3";